import api from '@/apis/di/topicAPI.js';
import Crud from '@/stores/crudBase.js';

var crud = new Crud('topic', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_topic',
    field: {
      key: 'topic_id',
      code: 'topic_code',
      name: 'topic_name',
      quickFollow: 'inactive',
    },
  },
};

const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
